import React from "react";
import { Row, Col , Grid,PageHeader } from 'react-bootstrap'
import Carousel from 'nuka-carousel';
import ScrollAnimation from 'react-animate-on-scroll';
import AdSense from 'react-adsense';

class Footer extends React.Component {

render() {
    
  return (
    <div>


    <div className="footer">
    <div className="container">
      <div className="row">
        <div className="col-md-4">
        <ScrollAnimation animateIn="fadeInLeft"
               			animateOnce={true}>
          <div className="footer-logo">
            <img src={require("../../img/Home/Logo-footer.png")} />
          </div>
   
          <ul className="social-network social-circle">
            <li><a href="#" className="icoFacebook" title="Facebook"><i className="fa fa-facebook" /></a></li>
            <li><a href="#" className="icoTwitter" title="Twitter"><i className="fa fa-twitter" /></a></li>
            <li><a href="#" className="icoyoutube" title="youtube"><i className="fa fa-youtube" /></a></li>

            <li><a href="#" className="icoinstgram" title="Dribble"><i className="fa fa-instagram" /></a></li>
          </ul>
          </ScrollAnimation>

        </div>
        <div className="col-md-8">
        <ScrollAnimation animateIn="fadeInRight"
               			animateOnce={true}>
          <div className="row">
            <div className="col-md-3">
              <div className="footer__menu-holder footer-border">
                <div className="footer-menu-title">
                  <h3> Categories</h3>
                </div>
                <ul className="footer__menu">
                  <li className="footer__menu-link"><a href="/shop"> Jeans</a></li>
                  <li className="footer__menu-link"><a href="/shop">	T-Shirts</a></li>
                  <li className="footer__menu-link"><a href="/shop">Shirts</a></li>
                  <li className="footer__menu-link"><a href="/shop">  Shoes</a></li>
                  <li className="footer__menu-link"><a href="/shop">   Accessories</a></li>

                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer__menu-holder footer-border">
                <div className="footer-menu-title">
                <h3> Product</h3>
                </div>
                <ul className="footer__menu">
                  <li className="footer__menu-link"><a href="/shop">  New Arrival</a></li>
                  <li className="footer__menu-link"><a href="/shop"> Popular Products</a></li>
                  <li className="footer__menu-link"><a href="/shop"> Trending Products</a></li>
                  <li className="footer__menu-link"><a href="/shop">  Trends Brands</a></li>
                  <li className="footer__menu-link"><a href="/shop">   Best Sellers</a></li>

                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer__menu-holder footer-border">
                <div className="footer-menu-title">
                <h3>  My Account</h3>
              

                </div>
                <ul className="footer__menu">
                  <li className="footer__menu-link"><a href="/userprofile">  My Profile</a></li>
                  <li className="footer__menu-link"><a href="/ordershistory">My Orders</a></li>
                  <li className="footer__menu-link"><a href="/wishlist">My Wishlist</a></li>
                  <li className="footer__menu-link"><a href="/paymentmethod">My Payment</a></li>
                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer__menu-holder ">
                <div className="footer-menu-title">
                <h3>Address</h3>
                </div>
                {/* <div className="footer-caption">
            <p> Lorem ipsum dolor sit amet, consectetur adipisicing<br /> elit, sed do eiusmod.</p>
          </div> */}
          <div className="footer_information">
            <div className="footer-address">
              <h3>Nasr City , Egypt 9 Hafez Ramadan St. of Ahmed Fakhry St. <br />
              6th District
              </h3>
            </div>
            <br/>
            <div className="footer-phone">
              <h3>
              Call Us:<br/> (+2) 123-456-789
              </h3></div>
          </div>
              </div>
            </div>
          </div>
          </ScrollAnimation>

        </div>
        <div className="footer__payment">
          {/* <img src={require("../../img/Homepage/footer/PaypalLogo.png")} />
          <img src={require("../../img/Homepage/footer/VisaLogo.png")} />
          <img src={require("../../img/Homepage/footer/MastercardLogo.png")} /> */}

   




 

        </div>
      </div>
    </div>
  </div>
  </div>

  
      );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx